import { deleteUserDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const deleteUserCallable = getCallable(deleteUserDefinition);
